if (!customElements.get('addon-popup')) {
  customElements.define(
    'addon-popup',
    class AddonPopup extends HTMLElement {
      connectedCallback() {
        this.shown = false;
        this.dialog = this.querySelector('.addon-popup__dialog');
        this.addButton = this.querySelector('[data-addon-add]');
        this.errorEl = this.querySelector('.addon-popup__error');

        this.querySelectorAll('[data-addon-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.addButton.addEventListener('click', () => this.add());
        this.addEventListener('keydown', (event) => this.onKeyDown(event));

        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      // Opens once per page load when a cart change leaves 2 or more other products in the cart,
      // the gift isn't in the cart yet and the shopper hasn't said "No thanks" this session.
      onCartUpdate(event) {
        if (this.shown || event?.source === 'addon-popup' || this.declined()) return;

        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
          .then((response) => response.json())
          .then((cart) => {
            const items = cart.items || [];
            const inCart = items.some((item) => String(item.product_id) === this.dataset.productId);
            const others = items
              .filter((item) => String(item.product_id) !== this.dataset.productId)
              .reduce((sum, item) => sum + item.quantity, 0);
            if (inCart || others < 2 || this.shown) return;
            // Let the cart drawer finish sliding in first.
            setTimeout(() => this.open(), 700);
          })
          .catch((e) => console.error(e));
      }

      declined() {
        try {
          return sessionStorage.getItem('feld-gift-declined') === '1';
        } catch (e) {
          return false;
        }
      }

      open() {
        this.shown = true;
        this.previousFocus = document.activeElement;
        this.hidden = false;
        this.dialog.getBoundingClientRect(); // start the enter transition from the hidden state
        this.classList.add('is-open');
        this.addButton.focus({ preventScroll: true });
      }

      close() {
        if (this.hidden) return;
        if (!this.classList.contains('is-added')) {
          try {
            sessionStorage.setItem('feld-gift-declined', '1');
          } catch (e) {}
        }
        this.classList.remove('is-open');
        setTimeout(() => {
          this.hidden = true;
          this.classList.remove('is-added');
          this.previousFocus?.focus?.({ preventScroll: true });
        }, 350);
      }

      add() {
        const cart = document.querySelector('cart-drawer');
        const body = { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] };
        if (cart?.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        this.addButton.setAttribute('aria-busy', 'true');
        this.errorEl.hidden = true;

        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.errorEl.textContent = response.description || response.message;
              this.errorEl.hidden = false;
              return;
            }

            if (window.location.pathname.endsWith('/cart')) {
              window.location.reload();
              return;
            }

            if (cart && response.sections) cart.renderContents(response);
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'addon-popup', cartData: response });
            }
            this.classList.add('is-added');
            setTimeout(() => this.close(), 1600);
          })
          .catch((e) => {
            console.error(e);
            this.errorEl.textContent = window.cartStrings?.error || 'Something went wrong. Please try again.';
            this.errorEl.hidden = false;
          })
          .finally(() => this.addButton.removeAttribute('aria-busy'));
      }

      // Escape closes; Tab stays inside the dialog.
      onKeyDown(event) {
        if (event.key === 'Escape') {
          event.stopPropagation();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...this.dialog.querySelectorAll('button:not([disabled]), [href]')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );
}
